import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { DateIcon } from 'foundations-assets/icons/components/DateIcon';
import { SuccessIcon } from 'foundations-assets/icons/components/SuccessIcon';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getEventTypeMessageKey = eventType => typeof eventType === 'string' ? `academyCommon.liveEventTypes.${eventType}` : 'academyCommon.liveEventTypes.WORKSHOP';
const getRegistrationStatus = ({
  attended,
  nextRegisteredSession
}) => {
  if (attended) return 'attended-before';
  if (!nextRegisteredSession) return 'not-registered';
  if (nextRegisteredSession.status === 'STARTED') return 'live';
  if (nextRegisteredSession.status === 'ENDED') return 'registered-before';
  return 'registered';
};
const SessionTimeDisplay = ({
  session
}) => {
  var _session$startTimeMs;
  if (session.startTimeMs == null) return null;
  const startTime = (_session$startTimeMs = session.startTimeMs) !== null && _session$startTimeMs !== void 0 ? _session$startTimeMs : 0;
  const endTime = startTime + session.durationMinutes * 60000;
  return /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "learningCenter.liveEventOverviewModal.sessionTimeWithoutDuration",
    options: {
      date: /*#__PURE__*/_jsx(FormattedDateTime, {
        format: "short-date",
        type: "userTz",
        value: startTime
      }),
      startTime: /*#__PURE__*/_jsx(FormattedDateTime, {
        format: "LT",
        type: "userTz",
        value: startTime
      }),
      endTime: /*#__PURE__*/_jsx(FormattedDateTime, {
        format: "LT",
        type: "userTz",
        value: endTime
      })
    }
  });
};
const LiveDot = ({
  color
}) => /*#__PURE__*/_jsx(Flex, {
  backgroundColor: color,
  blockSize: "8px",
  borderRadius: "full",
  inlineSize: "8px"
});
const RegistrationStatusBadge = ({
  status
}) => {
  if (status === 'live') {
    return /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      gap: "200",
      children: [/*#__PURE__*/_jsx(LiveDot, {
        color: "fill-alert-default"
      }), /*#__PURE__*/_jsx(Text, {
        as: "small",
        color: "text-alert-default",
        typography: "heading-50",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyCommon.liveEventRegistration.live"
        })
      })]
    });
  }
  if (status === 'registered') {
    return /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      gap: "200",
      children: [/*#__PURE__*/_jsx(LiveDot, {
        color: "fill-positive-default"
      }), /*#__PURE__*/_jsx(Text, {
        as: "small",
        color: "text-core-subtle",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyCommon.liveEventRegistration.registered"
        })
      })]
    });
  }
  const message = status === 'attended-before' ? 'academyCommon.liveEventRegistration.attendedBefore' : 'academyCommon.liveEventRegistration.registeredBefore';
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    gap: "200",
    children: [/*#__PURE__*/_jsx(SuccessIcon, {
      color: "icon-core-subtle",
      size: "200"
    }), /*#__PURE__*/_jsx(Text, {
      as: "small",
      color: "text-core-subtle",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: message
      })
    })]
  });
};
export const LiveEventFooter = ({
  eventType,
  nextUpcomingEventSession,
  nextRegisteredSession,
  attended
}) => {
  const registrationStatus = getRegistrationStatus({
    attended,
    nextRegisteredSession
  });
  const displayedSession = nextRegisteredSession !== null && nextRegisteredSession !== void 0 ? nextRegisteredSession : nextUpcomingEventSession;
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    gap: "200",
    children: [/*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      gap: "200",
      children: [/*#__PURE__*/_jsx(DateIcon, {
        color: "fill-accent-orange-default",
        size: "200"
      }), /*#__PURE__*/_jsx(Text, {
        as: "small",
        use: "help",
        children: /*#__PURE__*/_jsxs(List, {
          use: "inline-divided",
          children: [/*#__PURE__*/_jsx(ListItem, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: getEventTypeMessageKey(eventType)
            })
          }), displayedSession && /*#__PURE__*/_jsx(ListItem, {
            children: /*#__PURE__*/_jsx(SessionTimeDisplay, {
              session: displayedSession
            })
          })]
        })
      })]
    }), registrationStatus !== 'not-registered' && /*#__PURE__*/_jsx(RegistrationStatusBadge, {
      status: registrationStatus
    })]
  });
};
export default LiveEventFooter;